<template>
  <div :class="styleType == 'flex' ? 'cus-radio' : 'cus-radio-block'">
    <el-radio
      v-model="modelValue"
      v-for="item in data"
      :label="item.id"
      :key="item.id"
      v-bind="item.bindObj||{}"
    >
      <template v-if="item.type == 'none'"> {{ item.title }} </template>
      <template v-if="item.type == 'input'">
        <span style="margin-right: 12px"> {{ item.beforeName }}</span>
        <el-input
          style="width: 120px"
          v-model="valueInfo"
          :disabled="modelValue != item.id"
          :placeholder="item.placeholder"
          type="number"
        ></el-input>
        <span style="margin-left: 6px">
          {{ item.afterName }}
        </span>
      </template>
      <template v-if="item.type == 'time'">
        <span style="margin-right: 12px"> {{ item.beforeName }}</span>
        <el-date-picker
          :disabled="modelValue != item.id"
          :picker-options="pickerOptions"
          v-model="valueRange"
          type="datetimerange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width:360px;"
        >
        </el-date-picker>
      </template>
    </el-radio>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-unified";

export default {
  props: {
    useValue: {
      type: [String, Number],
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    styleType: {
      type: String,
      default: "",
    },
    isModel: {
      type: Boolean,
      default: true,
    },
    timeRange:{
        type: [Array,String],
      default: '',
    }
  },
  data() {
    return {
      infos: "",
    };
  },
  computed: {
    modelValue: {
      get() {
        console.log(this.value, "value----");
        return cloneDeep(this.value);
      },
      set(news) {
        console.log(news, "news----");
        this.$emit("input", news);
        return news;
      },
    },
    valueInfo: {
      get() {
        console.log(this.useValue, "useValue----");
        return cloneDeep(this.useValue);
      },
      set(news) {
        console.log(news, "news----");
        let data = this.styleType=='block'?news>=30?30:news:news
        this.$emit("changeValue", data);
        return data;
      },
    },
    valueRange:{
        get() {
        console.log(this.timeRange, "timeRange----");
        return cloneDeep(this.timeRange);
      },
      set(news) {
        console.log(news, "news----");
        this.$emit("changeValueRange", news);
        return news;
      },
    },
    pickerOptions() {
      let minDate = "";
      return {
        onPick: (obj) => {
          minDate = obj.minDate;
        },
        disabledDate: (time) => {
          if (minDate) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = minDate.getTime() - one;
            const maxTime = minDate.getTime() + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      };
    },
  },
};
</script>

<style lang="less">
.cus-radio {
  display: flex;
  align-items: center;
  height: 40px;
}
.cus-radio-block {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 90px;
  justify-content: space-between;
  .el-radio-group {
    .el-radio {
      margin-bottom: 10px;
    }
  }
}
</style>